import { createSlice } from '@reduxjs/toolkit'
import { FavouriteBillersResponse } from 'api/endpoints/billpayments/types'

type BillPatmentTypes = {
  favourateBillers: FavouriteBillersResponse,
}

const initialState: BillPatmentTypes = {
  favourateBillers: [],
}

const BillPaymentSlice = createSlice({
  name: 'billpayment',
  initialState,
  reducers: {
    setFavourateBillers: (state, action) => {
      state.favourateBillers = action.payload
    },
  },
})

export const { setFavourateBillers } = BillPaymentSlice.actions
export const selectFavourateBillers = (state: { billpayment: BillPatmentTypes, }) => state.billpayment.favourateBillers
export default BillPaymentSlice.reducer
